import React, { Fragment } from "react";
import {
  CanvasProvider,
  Manifest,
  OpenSeadragonViewer,
  SingleTileSource
} from "@canvas-panel/core";
import Viewport from "@canvas-panel/core/lib/viewers/Viewport/Viewport";
import OpenSeadragonViewport from "@canvas-panel/core/lib/viewers/OpenSeadragonViewport/OpenSeadragonViewport";
import AnnotationListProvider from "@canvas-panel/core/lib/manifesto/AnnotationListProvider/AnnotationListProvider";
import AnnotationProvider from "@canvas-panel/core/lib/manifesto/AnnotationProvider/AnnotationProvider";
import CanvasRepresentation from "@canvas-panel/core/lib/components/CanvasRepresentation/CanvasRepresentation";

const defaultMaxHeight = 675;
const defaultRatio = 1;

const IIIFCanvas = ({
  manifestUrl,
  options,
  annotations,
  renderAnnotation,
  renderNavigation,
  renderAnnotationDetail,
  initViewer,
  includeManifestAnnotations
}) => {
  const { maxHeight, ratio, osdOptions } = options || {};
  const annotations_ = annotations || [];
  return (
    <Manifest url={manifestUrl}>
      <CanvasProvider>
        {canvasProps => (
          <Fragment>
            <SingleTileSource {...canvasProps}>
              <Viewport
                getRef={ref => (initViewer ? initViewer(ref.viewer) : null)}
                maxHeight={maxHeight || defaultMaxHeight}
              >
                <OpenSeadragonViewport viewportController>
                  <OpenSeadragonViewer
                    maxHeight={maxHeight || defaultMaxHeight}
                    osdOptions={osdOptions}
                  />
                </OpenSeadragonViewport>

                {includeManifestAnnotations && (
                  <AnnotationListProvider ratio={ratio || defaultRatio}>
                    <AnnotationProvider>
                      {({ annotations, ...props }) => (
                        <CanvasRepresentation ratio={ratio} {...props}>
                          {annotations.map(renderAnnotation)}
                        </CanvasRepresentation>
                      )}
                    </AnnotationProvider>
                  </AnnotationListProvider>
                )}

                <CanvasRepresentation ratio={ratio || defaultRatio}>
                  {annotations_.map(renderAnnotation)}
                </CanvasRepresentation>
              </Viewport>
            </SingleTileSource>
            {renderNavigation && renderNavigation(canvasProps)}
            {renderAnnotationDetail && renderAnnotationDetail()}
          </Fragment>
        )}
      </CanvasProvider>
    </Manifest>
  );
};

export default IIIFCanvas;
